import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { StatusIcon } from './StatusIcon';
import { ExternalLinkIcon } from 'lucide-react';
import { canNavigateToSubtramite, getSubtramiteRoutePath } from '@/common/utils/subtramiteNavigation';
import { useNavigate } from 'react-router-dom';
import { SubtramiteEstado } from '@/subtramites/types';

interface SubtramiteRowProps {
  subtramite: {
    label: string;
    status: SubtramiteEstado;
    key: string;
  };
  tramite: any;
}

const getStatusLabel = (status: string) => {
  switch (status) {
    case 'pendiente':
      return 'Sin iniciar';
    case 'en-proceso':
      return 'En Proceso';
    case 'finalizado':
      return 'Finalizado';
    default:
      return 'Desconocido';
  }
}

const getStatusBadgeClasses = (status: string) => {
  switch (status) {
    case 'pendiente':
      return "bg-gray-100 text-gray-800";
    case 'en-proceso':
      return "bg-orange-100 text-orange-800";
    case 'finalizado':
      return "bg-green-100 text-green-800";
    default:
      return "bg-gray-100 text-gray-800";
  }
}

export const SubtramiteRow: React.FC<SubtramiteRowProps> = ({
  subtramite,
  tramite,
}) => {
  const navigate = useNavigate();
  const { label, status } = subtramite;

  const routePath = getSubtramiteRoutePath(label, tramite.id);
  const canNavigate = canNavigateToSubtramite(status);

  return (
    <div className="flex items-center justify-between p-2 rounded-md hover:bg-gray-50">
      <div className="flex items-center space-x-2 flex-1 min-w-0">
        <StatusIcon status={status} />
        <span className="text-sm font-medium text-gray-900 truncate">{label}</span>
      </div>
      <div className="flex items-center space-x-2 ml-2">
        <Badge className={`text-xs font-medium ${getStatusBadgeClasses(status)}`}>
          {getStatusLabel(status)}
        </Badge>
        {canNavigate && (
          <Button
            variant="ghost"
            size="sm"
            className='text-xs text-primary'
            disabled={!routePath || routePath === "/otros"}
            onClick={() => routePath && navigate(routePath, { state: { tramite: tramite } })}
          >
            <ExternalLinkIcon className="w-4 h-4" />
          </Button>
        )}
      </div>
    </div>
  );
};
